import * as client_hooks from '../../../src/hooks.client.js';
import * as universal_hooks from '../../../src/hooks.js';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [5];

export const dictionary = {
		"/": [8],
		"/about": [9,[2]],
		"/about/code-of-conduct": [10,[2]],
		"/about/contact-us": [11,[2]],
		"/about/registration": [12,[2]],
		"/attend": [13,[3]],
		"/attend/social": [14,[3]],
		"/attend/travel-grant": [16,[3]],
		"/attend/travel": [15,[3]],
		"/attend/volunteer": [17,[3]],
		"/cfp": [18],
		"/coc": [~19],
		"/news": [20,[4]],
		"/news/[id]": [21,[4]],
		"/photos": [~22],
		"/posters": [23],
		"/schedule": [~24,[5]],
		"/schedule/community-office-hours": [~25,[5]],
		"/schedule/friday": [~26,[5]],
		"/schedule/thursday": [~27,[5]],
		"/schedule/tuesday": [~28,[5]],
		"/schedule/wednesday": [~29,[5]],
		"/session/[id]": [~30,[6]],
		"/sponsor-levels": [~33],
		"/sponsor": [31,[7]],
		"/sponsor/levels": [~32,[7]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';